module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-music-df8da9018277bd3243ab78f8d388f448.png";